import { proxy } from 'valtio';
export const sungopStockStore = proxy({
    stockType: 'tw50',
    menuSymbolMode: 'instantSignal',
    marketViewMode: 'AboveAvgLine',
});
